<template>
    <div>
        <h2>This is Catering Body Section</h2>
    </div>
</template>
  
<script>
  export default {
    name: 'CateringBody'
  }
</script>
  
<style scoped>
 
</style>